import {Box} from 'components/Grid';
import {FC} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';

export const EmptyEventsState: FC = () => {
    return (
        <Box>
            <div className={style.container}>
                <Typography
                    className={style.title}
                    variants={{
                        DT: 'headline-32-reg-ch',
                        TB: 'headline-32-reg-ch',
                        MB: 'ch-title-24-reg',
                    }}
                >
                    По этим параметрам пока нет мероприятий
                </Typography>
            </div>
        </Box>
    );
};
